export default __webpack_public_path__ + "static/media/Edible.e32e5694.pdf";